import React from 'react';
import {
  classes,
  placeHeaderMetadataLabelClass,
  placeHeaderMetadataLinkClass,
  placeHeaderMetadataValueClass,
  TableauUser,
  UserLinkDisplayComponent,
  UserLinkProps,
} from '../../../data-catalog-shared';

export type PlaceHeaderMetadataTableauUserProps = {
  readonly tableauUser: TableauUser | null;
  readonly labelText: string;
};

/**
 * Renders a user, formatted for use in the place page header
 * @param props
 */
export function PlaceHeaderMetadataTableauUser(props: PlaceHeaderMetadataTableauUserProps): JSX.Element {
  return (
    <>
      <span className={placeHeaderMetadataLabelClass}>{props.labelText}</span>
      <UserLinkDisplayComponent
        user={props.tableauUser}
        linkComponent={PlaceHeaderUserLink}
      />
    </>
  );
}

function PlaceHeaderUserLink(props: UserLinkProps): JSX.Element {
  return (
    <a
      href={props.url}
      target='_blank'
      className={classes(placeHeaderMetadataLinkClass, placeHeaderMetadataValueClass)}
      title={props.name} rel="noreferrer"
    >
      {props.name}
    </a>
  );
}
